<template>
  <div v-if="!(selected == 'cancel' && isSuccess)">
    <div v-if="isShow"
      :class="['successful fadeDown', { 'error-msg': !isSuccess }]"
      @click="$emit('result')">
      <div v-if="selected === 'profile'" id="profile_msg">
        <div v-if="isSuccess">
          <p>{{ $t("profile.successful") }}</p>
          {{ $t("email_send") }}
        </div>
        <div v-else>
          <p v-if="isD2error">
            <i class="fas fa-exclamation-triangle"></i><span
              v-html="$t('error.d2p_norecode')"></span>
          </p>
          <p v-else>
            <i class="fas fa-exclamation-triangle"></i><span
              v-html="$t('profile.error')"></span>
          </p>
        </div>
      </div>
      <div v-if="selected === 'payment'" id="payment_msg">
        <div v-if="isSuccess">
          <p>{{ $t("payment.successful") }}<br>
            {{ $t("email_send") }}</p>
        </div>
        <div v-else>
          <p>{{ selected }}
            <i class="fas fa-exclamation-triangle"></i><span
              v-html="$t('payment.error')"></span>
          </p>
        </div>
      </div>
      <div v-if="selected === 'cancel'" id="cancel_msg">
        <div v-if="!isSuccess">
          <p><i class="fas fa-exclamation-triangle"></i><span
              id="cancel_error_msg" v-html="$t('cancel.error')"></span>
          </p>
        </div>
      </div>
      <div v-if="selected === 'reset'" id="reset_msg">
        <div v-if="isSuccess">
          <p>{{ $t("reset.successful") }}</p>
        </div>
        <div v-else>
          <p>
            <i class="fas fa-exclamation-triangle"></i><span
              v-html="$t('reset.error')"></span>
          </p>
        </div>
      </div>
      <div v-if="selected === 'invoice'" id="invoice_msg">
        <div v-if="isSuccess">
          <p>{{ $t("invoice.successful") }}<br>
            {{ $t("email_send") }}
          </p>
        </div>
        <div v-else>
          <p>
            <i class="fas fa-exclamation-triangle"></i><span
              v-html="$t('invoice.error')"></span>
          </p>
        </div>
      </div>
      <div v-if="selected === 'reply'" id="mail_msg">
        <p v-if="isSuccess">{{ $t("mail.send") }}</p>
        <p v-else>
          <i class="fas fa-exclamation-triangle"></i><span
            v-html="$t('mail.error')"></span>
        </p>
      </div>
      <div v-if="selected === 'mail_del'" id="mail_msg">
        <p v-if="isSuccess">{{ $t("mail.del.successful") }}</p>
        <p v-else>
          <i class="fas fa-exclamation-triangle"></i><span
            v-html="$t('mail.del.error')"></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Message",
  props: [
    "isShow",
    "isSuccess",
    "isSuccess2",
    "selected",
    "options",
    "isD2error",
    "prefer_lang"
  ],
  watch: {
    "isSuccess": {
      handler(e) {
        if (e && this.selected === 'cancel') {
          this.$router.push('/canceled');
        }
      }
    }
  }
}
</script>